var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-icon"},[_c('i',{staticClass:"icon",style:({
      width: _vm.iconWidth,
      height: _vm.iconHeight,
      backgroundPosition: _vm.iconPosition
    })}),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }